import { useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";

import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { Edit2Icon } from "lucide-react";

export function EditNiftyRegimeConfigModal({
  rowData,
  handleEditNiftyLotConfig,
}) {
  const [open, setOpen] = useState(false);

  const [niftyLotConfig, setNiftyLotConfig] = useState({
    r000: rowData?.r000,
    r001: rowData?.r001,
    r010: rowData?.r010,
    r011: rowData?.r011,
    r100: rowData?.r100,
    r101: rowData?.r101,
    r110: rowData?.r110,
    r111: rowData?.r111,
    s000: rowData?.s000,
    s001: rowData?.s001,
    s010: rowData?.s010,
    s011: rowData?.s011,
    s100: rowData?.s100,
    s101: rowData?.s101,
    s110: rowData?.s110,
    s111: rowData?.s111,
    f000: rowData?.f000,
    f001: rowData?.f001,
    f010: rowData?.f010,
    f011: rowData?.f011,
    f100: rowData?.f100,
    f101: rowData?.f101,
    f110: rowData?.f110,
    f111: rowData?.f111,
  });

  const handleEditNiftyRegimeConfig = () => {
    handleEditNiftyLotConfig(
      rowData?.strategy,
      rowData.option_type,
      niftyLotConfig
    );
    setOpen(false);
  };

  const handleChange = (key, value) => {
    setNiftyLotConfig((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-zinc-800 text-white px-2.5 hover:bg-zinc-700  rounded-[5px]">
          <Edit2Icon className="w-4 h-4 " />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[725px] border-zinc-700">
        <DialogHeader>
          <DialogTitle className="text-white">
            Edit Nifty Regime Config
          </DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-3 gap-4 py-4">
          {Object.keys(niftyLotConfig)
            .filter((key) => key !== "clientId")
            .map((key) => (
              <div key={key} className="grid grid-cols-1 items-center gap-4">
                <Label className="text-white">{key.toUpperCase()}</Label>
                <Input
                  type="number"
                  placeholder={`Enter ${key}`}
                  className="text-white"
                  value={niftyLotConfig[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                />
              </div>
            ))}
        </div>
        <DialogFooter>
          <Button
            type="submit"
            className="text-[16px] font-normal bg-zinc-800 text-white hover:bg-zinc-700"
            onClick={handleEditNiftyRegimeConfig}
          >
            Update Nifty Config
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
